import { generateTrackingId } from '@frontend/call-intel-core';

const TRIAL_TEASER_COMPONENT = 'insights-trial-teaser';

type TrialTeaserTrackingIdOptions = {
  isAdmin: boolean;
  context: string;
  prefix?: string;
};

export const generateCallInsightTeaserTrackingIds = ({ isAdmin, context, prefix }: TrialTeaserTrackingIdOptions) =>
  generateTrackingId({
    prefix,
    component: TRIAL_TEASER_COMPONENT,
    context: `${isAdmin ? 'admin' : 'user'}-${context}`,
  });

const CallIntelTrialTeaserCtaContexts = {
  view: 'view',
  startFreeTrial: 'start-free-trial',
  requestTrial: 'request-trial',
  viewDemo: 'view-demo',
  maybeLater: 'maybe-later',
} as const;

export const getCallIntelTrialTeaserTrackingIds = (isAdmin: boolean, prefix?: string) => ({
  view: generateCallInsightTeaserTrackingIds({ isAdmin, context: CallIntelTrialTeaserCtaContexts.view, prefix }),
  startFreeTrial: generateCallInsightTeaserTrackingIds({
    isAdmin,
    context: CallIntelTrialTeaserCtaContexts.startFreeTrial,
    prefix,
  }),
  requestTrial: generateCallInsightTeaserTrackingIds({
    isAdmin,
    context: CallIntelTrialTeaserCtaContexts.requestTrial,
    prefix,
  }),
  viewDemo: generateCallInsightTeaserTrackingIds({
    isAdmin,
    context: CallIntelTrialTeaserCtaContexts.viewDemo,
    prefix,
  }),
  maybeLater: generateCallInsightTeaserTrackingIds({
    isAdmin,
    context: CallIntelTrialTeaserCtaContexts.maybeLater,
    prefix,
  }),
});

export const CallIntelTrialTeaserTrackingIds = {
  admin: getCallIntelTrialTeaserTrackingIds(true),
  user: getCallIntelTrialTeaserTrackingIds(false),
} as const;
